import { Injectable } from '@angular/core';
import { gsap } from 'gsap';

@Injectable({
  providedIn: 'root',
})
export class FancyCircleOverlayService {
  dom: HTMLDivElement;

  constructor() {}

  hideAnimation() {
    gsap.to(this.dom.firstChild, {
      duration: 1,
      ease: 'power2.in',
      scale: 1,
      onComplete: () => {
        document.body.removeChild(this.dom);
      },
    });
  }

  showAnimation(duration = 1, color = 'lightblue', text = ''): Promise<any> {
    return new Promise<any>((resolve) => {
      if (!this.dom) {
        const element = document.createElement('div');
        element.style.position = 'fixed';
        element.style.top = '0';
        element.style.left = '0';
        element.style.width = '100vw';
        element.style.height = '100vh';
        element.style.pointerEvents = 'none';
        element.style.display = 'flex';
        element.style.justifyContent = 'center';
        element.style.alignItems = 'center';
        element.style.zIndex = '2147483647';
        const child = document.createElement('div');
        child.style.borderRadius = '50%';
        child.style.width = '50px';
        child.style.height = '50px';
        child.style.backgroundColor = color;
        child.style.display = 'flex';
        child.style.justifyContent = 'center';
        child.style.alignItems = 'center';
        child.style.whiteSpace = 'nowrap';
        element.appendChild(child);

        this.dom = element;
      }
      document.body.appendChild(this.dom);
      const scale = Math.max(window.innerWidth, window.innerHeight) / 30;
      gsap.to(this.dom.firstChild, {
        duration,
        onComplete: resolve,
        scale,
      });

      console.log('test');
    });
  }
}
